export enum OperationFinancialInstrumentEnumFR {
	ACTIONS = 'ACTIONS',
	OBLIGATIONS = 'OBLIGATIONS',
	TITRES_PARTICIPATIFS = 'TITRES_PARTICIPATIFS',
	PARTS_FIA = 'PARTS_FIA',
	DONS = 'DONS'
}

export enum OperationFinancialInstrumentEnum {
	STOCKS = 'STOCKS',
	BONDS = 'BONDS',
	EQUITY_SECURITIES = 'EQUITY_SECURITIES',
	AIF_SHARES = 'AIF_SHARES',
	DONATIONS = 'DONATIONS'
}

export const getOperationFinancialInstrumentFromFR = (
	e: OperationFinancialInstrumentEnumFR
): OperationFinancialInstrumentEnum => {
	switch (e) {
		case OperationFinancialInstrumentEnumFR.ACTIONS:
			return OperationFinancialInstrumentEnum.STOCKS;
		case OperationFinancialInstrumentEnumFR.OBLIGATIONS:
			return OperationFinancialInstrumentEnum.BONDS;
		case OperationFinancialInstrumentEnumFR.TITRES_PARTICIPATIFS:
			return OperationFinancialInstrumentEnum.EQUITY_SECURITIES;
		case OperationFinancialInstrumentEnumFR.PARTS_FIA:
			return OperationFinancialInstrumentEnum.AIF_SHARES;
		case OperationFinancialInstrumentEnumFR.DONS:
			return OperationFinancialInstrumentEnum.DONATIONS;
	}
};

export const getOperationFinancialInstrumentFromEN = (
	e: OperationFinancialInstrumentEnum
): OperationFinancialInstrumentEnumFR => {
	switch (e) {
		case OperationFinancialInstrumentEnum.STOCKS:
			return OperationFinancialInstrumentEnumFR.ACTIONS;
		case OperationFinancialInstrumentEnum.BONDS:
			return OperationFinancialInstrumentEnumFR.OBLIGATIONS;
		case OperationFinancialInstrumentEnum.EQUITY_SECURITIES:
			return OperationFinancialInstrumentEnumFR.TITRES_PARTICIPATIFS;
		case OperationFinancialInstrumentEnum.AIF_SHARES:
			return OperationFinancialInstrumentEnumFR.PARTS_FIA;
		case OperationFinancialInstrumentEnum.DONATIONS:
			return OperationFinancialInstrumentEnumFR.DONS;
	}
};

export const getOperationFinancialInstrumentArrayFromFr = (
	a: OperationFinancialInstrumentEnumFR[]
): OperationFinancialInstrumentEnum[] => {
	const financialInstrumentEnums: OperationFinancialInstrumentEnum[] = [];
	a.forEach((e) => {
		financialInstrumentEnums.push(getOperationFinancialInstrumentFromFR(e));
	});
	return financialInstrumentEnums;
};

export const getOperationFinancialInstrumentString = (
	e: OperationFinancialInstrumentEnum,
	$t: (_: string) => string
): string => {
	switch (e) {
		case OperationFinancialInstrumentEnum.STOCKS:
			return $t('operation.instruments.stocks');
		case OperationFinancialInstrumentEnum.BONDS:
			return $t('operation.instruments.bonds');
		case OperationFinancialInstrumentEnum.EQUITY_SECURITIES:
			return $t('operation.instruments.equity-securities');
		case OperationFinancialInstrumentEnum.AIF_SHARES:
			return $t('operation.instruments.shares-aif');
		case OperationFinancialInstrumentEnum.DONATIONS:
			return $t('operation.instruments.donations');
	}
	return '';
};
